import {Component, OnInit} from '@angular/core';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {ActivatedRoute} from '@angular/router';
import {JQueryStatic} from 'jquery';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';

declare var $: JQueryStatic;

@Component({
    selector: 'mapa-layout-modal',
    templateUrl: './mapa-layout-modal.component.html',
    styleUrls: ['./mapa-layout-modal.component.css']
})
export class MapaLayoutModalComponent {

    constructor(private globalService: GlobalService, public modalService: ModalService, private route: ActivatedRoute, private formBuilder: FormBuilder) {
    }

    private sub: any;

    erro: boolean = false;
    erro2: boolean = false;

    mapas = new Array<string>();
    layouts = new Array<string>();

    layoutEntrada = new FormControl('0', []);
    layoutSaida = new FormControl('0', []);

    mapaLayoutModalForm: FormGroup = this.formBuilder.group({
        layoutEntrada: this.layoutEntrada,
        layoutSaida: this.layoutSaida
    });

    ngOnInit() {
        this.erro = false;
        this.erro2 = false;
        this.sub = this.route
            .queryParams
            .subscribe(params => {
                if (params['mapas'] != '') {
                    this.mapas = params['mapas'];
                    this.carregarLayouts();
                }
            });
    }

    carregarLayouts() {
        this.mapas.forEach(mapa => {
            let temp = mapa.split('_');
            if (!~this.layouts.indexOf(temp[0])) {
                this.layouts.push(temp[0].toUpperCase());
            }
            if (!~this.layouts.indexOf(temp[2])) {
                this.layouts.push(temp[2].toUpperCase());
            }
        });
        this.layouts.sort();
    }

    verificarEntrada() {
        this.erro = false;
        this.erro2 = false;
        if (this.layoutEntrada.value == '999') {
            $('#layoutEntradaDesc').show();
        } else {
            $('#layoutEntradaDesc').hide();
        }
    }

    verificarSaida() {
        this.erro = false;
        this.erro2 = false;
        if (this.layoutSaida.value == '999') {
            $('#layoutSaidaDesc').show();
        } else {
            $('#layoutSaidaDesc').hide();
        }
    }

    confirmar() {
        if (this.layoutEntrada.value == this.layoutSaida.value) {
            this.erro2 = true;
            return false;
        }
        let novoMapa = this.layoutEntrada.value + '_PARA_' + this.layoutSaida.value;
        if (this.mapas.findIndex(item => novoMapa.toUpperCase() === item.toUpperCase()) > -1) {
            this.erro = true;
        } else {
            this.modalService.incluirDadosGerados(novoMapa);
            this.modalService.fecharPaginaModal();
        }
    }

    cancelar() {
        this.modalService.fecharPaginaModal();
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/mapa-layout-modal/mapa-layout-modal.component.ts